import { CustomAppState } from "@stoneage/App/Store/Reducers";

export function xngHasChanges(state: CustomAppState) {
    const { phone, name, email, urgencyOfResolution, serialNumber } = state.xRequestRma.properties;

    return (
        phone.length > 0 &&
        name.length > 0 &&
        email.length > 0 &&
        urgencyOfResolution.length > 0 &&
        serialNumber.length > 0 &&
        state.pages.requestRma.returnNotes && state.pages.requestRma.returnNotes?.length > 0
    );
}
